import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import api from 'services/api';
import Select from 'react-select';

const FlowProperties = ({ state, onChange }) => {
  const { config } = state;
  const [workflowDefinitions, setWorkflowDefinitions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  const fetchWorkflowDefinitions = async (search = '') => {
    try {
      setSearchLoading(true);
      const response = await api.get('/node_definitions', {
        params: {
          search,
          sortColumn: 'name',
          sortOrder: 'asc',
          type: 'workflowActionCreate',
          limit: 20,
        },
      });
      setWorkflowDefinitions(response.data.nodes || []);
    } catch (error) {
      console.error('Error fetching workflow definitions:', error);
    } finally {
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkflowDefinitions();
  }, []);

  return (
    <>
      <Form.Group className="mb-2" controlId="formOnError">
        <Form.Label>On Error</Form.Label>
        <Form.Select as="select" name="on_error" value={config?.on_error || ''} onChange={(e) => onChange(e, true)}>
          <option value="">Default (Raise Workflow and Wait)</option>
          <option value="raise_workflow_and_wait">Raise Workflow and Wait</option>
          <option value="abort">Abort</option>
        </Form.Select>
      </Form.Group>

      {config?.on_error === 'raise_workflow_and_wait' && (
        <Form.Group className="mb-2" controlId="formWorkflowDefinition">
          <Form.Label>Workflow Node Definition</Form.Label>
          <Select
            placeholder="Search and select a workflow definition..."
            isClearable
            isLoading={searchLoading}
            onInputChange={(inputValue) => {
              setSearchTerm(inputValue);
              if (inputValue.length < 2) {
                fetchWorkflowDefinitions();
              } else {
                fetchWorkflowDefinitions(inputValue);
              }
            }}
            options={workflowDefinitions.map((def) => ({
              value: `${def.zone_name}|${def.name}`,
              label: def.zone_name ? `${def.zone_name} - ${def.name}` : def.name,
            }))}
            value={
              config?.workflow_node_definition
                ? workflowDefinitions
                    .map((def) => ({
                      value: `${def.zone_name}|${def.name}`,
                      label: def.zone_name ? `${def.zone_name} - ${def.name}` : def.name,
                    }))
                    .find((option) => option.value === config.workflow_node_definition) || null
                : null
            }
            onChange={(selectedOption) => {
              const event = {
                target: {
                  name: 'workflow_node_definition',
                  value: selectedOption ? selectedOption.value : '',
                },
              };
              onChange(event, true);
            }}
          />
        </Form.Group>
      )}
    </>
  );
};

export default FlowProperties;
